import * as React from 'react'
import { Box, styled } from '@mui/material'
import { baseConfig, mathJax3Config } from './MathjaxLoader'
import { mathjaxLoadedAtom } from './atoms'
import { useAtom } from 'infrastructure/state/jotai.wrapper'

const MathBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  minHeight: '40px',
  '& div': {
    margin: 0,

    '& .MathJax': {
      margin: '4px !important',
    },
  },
})

export function MathjaxPreview({ math }: { math: string }) {
  const [loaded, setLoaded] = useAtom(mathjaxLoadedAtom)
  const previewRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!loaded) {
      window.MathJax = { ...baseConfig, ...(mathJax3Config ?? {}) }
    }
    if (!loaded && !document.getElementById('mathjax-script')) {
      const script = document.createElement('script')
      script.id = 'mathjax-script'
      script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js'
      script.async = true
      document.head.appendChild(script)
      script.onload = () => setLoaded(true)
    }
  }, [loaded, setLoaded])

  React.useEffect(() => {
    if (!previewRef.current || !loaded) return
    const processedMath = math.replace(/\\/g, '\\')
    previewRef.current.innerHTML = `\\(${processedMath}\\)`

    const typeset = async () => {
      if (window.MathJax?.startup?.promise) {
        await window.MathJax.startup.promise
      }
      if (window.MathJax?.typesetPromise) {
        window.MathJax.typesetPromise([previewRef.current])
      }
    }
    typeset()
  }, [loaded, math, previewRef])

  if (math.length === 0) return null

  return (
    <MathBox>
      <div className="react-mathjax-preview-result" ref={previewRef} />
    </MathBox>
  )
}
